import React from "react";
import "../JobBoardExpanded.scss";

function JobDetailsCard({
  jobDetails,
  formSubmitError,
  onApplyClick,
}) {

  return (
    <div className="job-expanded-info bg-white px-4 border-radius-10 border h-100">
      {jobDetails?.title && (
        <div className="bottom position-relative">
           <div className="text-right">
            {jobDetails && typeof jobDetails.already_applied === "object" && Object.keys(jobDetails.already_applied).length === 0 ? (
              <button
                className="btn btn-primary apply px-4"
                onClick={onApplyClick}
              >
                Apply
              </button>
            ) : jobDetails?.already_applied === "Not applied" ? (
              <button
                className="btn btn-primary apply px-4"
                onClick={onApplyClick}
              >
                Apply 
              </button>
            ) : (
              <p className="custom-tag tag-applied fs-14 mb-0 rounded-pill py-1 bg-light-blue  px-2 text-capitalize" disabled>
                {jobDetails?.already_applied}
              </p>
            )
            }
            {
              formSubmitError?.applied_msg && (
                <div className="d-flex align-items-center justify-content-between">
                  <span className="text-danger font-weight-medium">
                    {formSubmitError?.applied_msg}
                  </span>
                </div>
              )
            }
          </div>
         
          <div className="skills d-flex flex-wrap my-2">
            {Array.isArray(jobDetails?.skill_names) &&
              jobDetails?.skill_names &&
              jobDetails?.skill_names.length > 1 && (
                <>
                  <p className="font-weight-medium w-100">Key Skills</p>
                  {jobDetails?.skill_names &&
                    Array.isArray(jobDetails?.skill_names) &&
                    jobDetails?.skill_names.map((skill) => (
                      <span className="skill text-dark bg-grey-4 text-nowrap border px-2 rounded-lg text-capitalize mr-2 mb-2">
                        {skill}
                      </span>
                    ))}
                  <p className="text-muted d-inline-block">
                    {Array.isArray(jobDetails?.skill_names) &&
                      jobDetails?.skill_names &&
                      jobDetails.skill_names.length > 6
                      ? "..."
                      : null}
                  </p>
                </>
              )}
          </div>
          {jobDetails?.role_description &&
            <div className="mb-3">
              <p className="font-weight-medium">Job Description</p>
              <div
                className="text-grey-4"
                dangerouslySetInnerHTML={{
                  __html: jobDetails?.role_description,
                }}
              ></div>
            </div>
          }
          {jobDetails?.role_requirements &&
            <div className="mb-3">
              <p className="font-weight-medium">Requirements</p>
              <div
                className="text-grey-4"
                dangerouslySetInnerHTML={{
                  __html: jobDetails?.role_requirements,
                }}
              ></div>
            </div>
          }
          {jobDetails?.role_benefits &&
            <div className="mb-3">
              <p className="font-weight-medium">Benefits</p>
              <div
                className="text-grey-4"
                dangerouslySetInnerHTML={{
                  __html: jobDetails?.role_benefits,
                }}
              ></div>
            </div>
          }
        </div>
      )}
    </div>
  );
}

export default JobDetailsCard;
